import type { ArrayFieldTemplateProps } from '@rjsf/utils';
import { BadgePlus, Trash } from 'lucide-react';

import { Button } from '@/shadcn/button';
import { cn } from '@/shadcn/lib/utils';

export const ArrayFieldTemplate = ({
  title,
  items,
  canAdd,
  onAddClick,
  rawErrors
}: ArrayFieldTemplateProps) => {
  const error = rawErrors && rawErrors.length > 0;

  return (
    <div
      className={cn(
        'rounded-md border border-input p-2.5',
        error && 'border-destructive'
      )}
      data-has-error={error}
    >
      <div className="mb-3 font-semibold text-base">{title}</div>
      {items.map(item => (
        <div
          className="mb-5 rounded-sm border border-input p-3.5"
          key={item.index}
        >
          {item.children}
          {item.hasRemove && (
            <div className="flex flex-row justify-end">
              <Button
                onClick={e => {
                  item.onDropIndexClick(item.index)(e);
                }}
                size="icon"
                variant="ghostDestructiveSubtle"
              >
                <Trash />
              </Button>
            </div>
          )}
        </div>
      ))}
      {canAdd && (
        <Button onClick={onAddClick} variant="outline">
          <BadgePlus /> Add an item
        </Button>
      )}
    </div>
  );
};
